module.exports.isNode = false;




//////////////////
// WEBPACK FOOTER
// ./~/detect-node-es/es5/browser.js
// module id = 467
// module chunks = 0